// extracted by mini-css-extract-plugin
module.exports = {"meals":"AvailableMeals_meals__3oiLm","meals-appear":"AvailableMeals_meals-appear__2URfu"};